import React, { Component } from 'react';
import { connect } from "react-redux";
import SaveIcon from '../../../prat_screen/gt/images/draft.svg';
import CustomSelect from "../../../components/common/select/Select";
import ProductMiddleware from "../../../store/prat_middleware/gt/productMiddleware";
import InnovationMiddleware from '../../../store/middleware/innovationMiddleware';
import DurationMiddleware from "../../../store/prat_middleware/gt/durationMiddleware";
import { compare } from '../../../prat_screen/gt/validation/sort';
import { Loader } from "../../../components/loader";
import CustomToast from '../../../util-functions/customToast.jsx';
import InnovationFormTable from './InnovationFormTable';
import InnovationRegionChannelSplit from '../innovation-region-channel-split/InnovationRegionChannelSplit';
import './InnovationForm.styles.scss';

class InnovationForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedCategory: null,
            selectedBrand: null,
            selectedMasterSku: null,
            selectedReferenceMasterSku: null,
            myBrands: [],
            myMasterSkus: [],
            isDraftSaved: true,
            getData: true,
            isOpen: false,
            currentYearInnovationVolume: [],
            nextYearInnovationVolume: [],
            channelSplit: [],
            regionSplit: [],
            channelSplitTemp: [],
            regionSplitTemp: [],
            dummyCode: '',
            dummyDescription: '',
            promoStatus: 0,
            existingActivity: false,
            updateInno: false,
            weeksArray: [],
            selectedWeek: '',
            selectAllJCWeek: true,
            activating: false,
            csvFileReset: null
        }
    }

    componentDidMount() {
        let cpId = this.props.location.search.substr(4,);

        this.props.productCategories();
        this.props.productBrands();
        this.props.productMasterSkus();

        if (cpId) {
            this.props.getConsumerPromotionById(cpId);
            this.setState({
                existingActivity: true
            })
        }
        else {
            this.props.getStartWeek(new Date().getFullYear());
        }
    };

    handleCategory = value => {
        if (value && (value.value !== this.state.selectedCategory)) {
            this.setState({ selectedCategory: value.value, selectedBrand: null, selectedMasterSku: null }, () => {
                this.handleFilteredBrands();
                if (this.state.existingActivity) {
                    this.checkSingleValueForDraftCheck(this.state.selectedCategory, this.props.innovationById?.Category ? this.props.innovationById.Category : this.props.innovation.Category);
                } else {
                    this.setState({
                        isDraftSaved: false
                    })
                }
            });
        }
    };

    handleFilteredBrands = () => {
        const {
            selectedCategory
        } = this.state;
        const { productBrandsArray } = this.props;
        let filteredbrands = [];
        if (selectedCategory) {
            filteredbrands.push(
                ...productBrandsArray.filter(item => {
                    return item.Category === selectedCategory;
                })
            );
            this.setState({
                myBrands: filteredbrands
            }, () =>
                this.handleFilteredMasterSku()
            );
        }
    };

    handleBrandChange = value => {
        if (value && (value.value !== this.state.selectedBrand)) {
            this.setState({ selectedBrand: value.value, selectedMasterSku: null }, () => {
                this.handleFilteredMasterSku();
                if (this.state.existingActivity) {
                    this.checkSingleValueForDraftCheck(this.state.selectedBrand, this.props.innovationById?.Brand ? this.props.innovationById.Brand : this.props.innovation.Brand);
                } else {
                    this.setState({
                        isDraftSaved: false
                    })
                }
            });
        }
    };

    handleFilteredMasterSku = () => {
        const {
            selectedBrand,
        } = this.state;
        const { productMasterSkusArray } = this.props;
        let filteredSkus = [];
        if (selectedBrand) {
            filteredSkus.push(
                ...productMasterSkusArray.filter(item => {
                    return item.Brand === selectedBrand;
                })
            );
            this.setState({
                myMasterSkus: filteredSkus
            });
        }
    };

    handleMasterSkusChange = value => {
        if (value && (value.value !== this.state.selectedMasterSku)) {
            this.setState({ selectedMasterSku: value.value }, () => {
                // this.checkSingleValueForDraftCheck(this.state.selectedMasterSku, this.props.consumerPromotionById.MetaData.MasterSku);
            });
        }
    };

    handleReferenceMasterSkusChange = value => {
        if (value && (value.value !== this.state.selectedReferenceMasterSku)) {
            this.props.getRegionChannelSplitByMskuId(value.value);
            this.setState({ selectedReferenceMasterSku: value.value }, () => {
                if (this.state.existingActivity) {
                    this.checkSingleValueForDraftCheck(this.state.selectedReferenceMasterSku, this.props.innovationById?.ReferenceMasterSku ? this.props.innovationById.ReferenceMasterSku : this.props.innovation.ReferenceMasterSku);
                } else {
                    this.setState({
                        isDraftSaved: false
                    })
                }
            });
        }
    };

    handleDummySKUCodeChange = (e) => {
        this.setState({
            dummyCode: e.target.value
        }, () => {
            if (this.state.existingActivity) {
                this.checkSingleValueForDraftCheck(this.state.dummyCode, this.props.innovationById?.DummyCode ? this.props.innovationById.DummyCode : this.props.innovation.DummyCode);
            } else {
                this.setState({
                    isDraftSaved: false
                })
            }
        })
    };

    handleDummyDescriptionChange = (e) => {
        this.setState({
            dummyDescription: e.target.value
        }, () => {
            if (this.state.existingActivity) {
                this.checkSingleValueForDraftCheck(this.state.dummyDescription, this.props.innovationById?.DummyDescription ? this.props.innovationById.DummyDescription : this.props.innovation.DummyDescription);
            } else {
                this.setState({
                    isDraftSaved: false
                })
            }
        })
    };

    createInnovationVolumeList = weekArray => {
        if (weekArray?.length) {
            let firstWeek = weekArray[0].substr(5, 2);

            let currentYearInnovationVolume = [];
            let nextYearInnovationVolume = [];

            for (var i = (parseInt(firstWeek) + 1); i <= 52; i++) {
                currentYearInnovationVolume.push({
                    WeekNo: i,
                    Year: new Date().getFullYear(),
                    Volume: 0,
                    Innovation: ''
                })
            }

            for (var j = 1; j <= 52; j++) {
                nextYearInnovationVolume.push({
                    WeekNo: j,
                    Year: (new Date().getFullYear() + 1),
                    Volume: 0,
                    Innovation: ''
                })
            }

            this.setState({
                currentYearInnovationVolume,
                nextYearInnovationVolume
            })

        }
    };

    extractDataFromAPIResponse = (apiData) => {

        this.setState({
            dummyCode: apiData.DummyCode,
            dummyDescription: apiData.DummyDescription,
            promoStatus: apiData.Status,
            selectedCategory: apiData.Category,
            selectedBrand: apiData.Brand,
            selectedReferenceMasterSku: apiData.ReferenceMasterSku,
            channelSplit: [...apiData.Channel],
            regionSplit: [...apiData.Region],
            channelSplitTemp: this.groupRegionOrChannelData(apiData.Channel),
            regionSplitTemp: this.groupRegionOrChannelData(apiData.Region),
            currentYearInnovationVolume: apiData.Volume.filter(item => item.Year === new Date().getFullYear()),
            nextYearInnovationVolume: apiData.Volume.filter(item => item.Year === (new Date().getFullYear() + 1))
        }, () => {
            this.handleFilteredBrands();
        })
    };

    groupRegionOrChannelData = (data) => {
        if (data) {
            let arr = data.reduce((r, a) => {
                r[a.WeekNo] = [...r[a.WeekNo] || [], a];
                return r;
            }, {})

            if (arr) {
                let weeks = [];
                weeks = Object.keys(arr);

                this.setState({
                    weeksArray: weeks,
                    selectedWeek: this.state.selectedWeek ? this.state.selectedWeek : weeks[0]
                })
            }

            return arr;
        }
        else {
            return null;
        }
    };

    checkSingleValueForDraftCheck = (stateValue, propsValue) => {
        if (stateValue !== propsValue) {
            this.setState({
                isDraftSaved: false
            })
        }
    };

    checkArrayValueForDraftCheck = (stateValue, propsValue) => {
        if (stateValue?.length !== propsValue?.length) {
            this.setState({
                isDraftSaved: false
            })
        }
        else if (stateValue?.length && propsValue?.length) {
            let missCount = 0;
            for (var i = 0; i < stateValue.length; i++) {
                if (!stateValue.includes(propsValue[i])) {
                    missCount++;
                }
            }
            if (missCount) {
                this.setState({
                    isDraftSaved: false
                })
            }
        }
    };

    handleEmptyValidationCheck = () => {
        const { selectedBrand, selectedCategory, selectedReferenceMasterSku,
            dummyCode, dummyDescription, currentYearInnovationVolume, nextYearInnovationVolume
        } = this.state;
        let isTrue = true;
        let volumeCheck = false;
        let Volume = [...currentYearInnovationVolume, ...nextYearInnovationVolume];

        if (!dummyCode) {
            isTrue = false;
            CustomToast('error', 'Dummy MSKU Code is empty!');
        }
        if (!dummyDescription) {
            isTrue = false;
            CustomToast('error', 'Dummy MSKU Description is empty!');
        }
        if (!selectedCategory) {
            isTrue = false;
            CustomToast('error', 'Category is empty!');
        }
        if (!selectedBrand) {
            isTrue = false;
            CustomToast('error', 'Brand is empty!');
        }
        if (!selectedReferenceMasterSku) {
            isTrue = false;
            CustomToast('error', 'Reference MSKU is empty!');
        }
        if (Volume) {
            Volume.forEach(item => {
                if (item.Volume === 0) {
                    volumeCheck = true
                }
            })
        }
        if (volumeCheck) {
            isTrue = false;
            CustomToast('error', 'Innovation Volume is zero!');
        }



        return isTrue;
    };

    handleSaveDraft = () => {
        let validData = this.handleEmptyValidationCheck();
        let id = this.props.location.search.substr(4,);
        let data = {
            DummyCode: this.state.dummyCode,
            DummyDescription: this.state.dummyDescription,
            Status: this.state.promoStatus,
            Category: this.state.selectedCategory,
            Brand: this.state.selectedBrand,
            ReferenceMasterSku: this.state.selectedReferenceMasterSku,
            Channel: [...this.state.channelSplit],
            Region: [...this.state.regionSplit],
            Volume: [...this.state.currentYearInnovationVolume, ...this.state.nextYearInnovationVolume],
        }
        if (validData) {
            this.setState({
                updateInno: true
            }, () => {
                this.props.patchUpdateInnovation(id ? id : this.props.innovation.guid, data);
            })
        }
    };

    handleActivateAndDeactivateApiData = (value) => {
        let validData = this.handleEmptyValidationCheck();
        let id = this.props.location.search.substr(4,);

        let data = {
            DummyCode: this.state.dummyCode,
            DummyDescription: this.state.dummyDescription,
            Status: value,
            Category: this.state.selectedCategory,
            Brand: this.state.selectedBrand,
            ReferenceMasterSku: this.state.selectedReferenceMasterSku,
            Channel: [...this.state.channelSplit],
            Region: [...this.state.regionSplit],
            Volume: [...this.state.currentYearInnovationVolume, ...this.state.nextYearInnovationVolume],
        }
        if (validData) {
            this.setState({
                updateInno: true,
                activating: true
            }, () => {
                this.props.patchUpdateInnovation(id ? id : this.props.innovation.guid, data);
            })
        }
    }

    handleSubmitActivity = (value) => {

        if (value === 1) {  // if value is 1 activate cta is clicked
            this.handleActivateAndDeactivateApiData(value);
        }
        else if (value === 2) {
            this.handleActivateAndDeactivateApiData(value);
        }
        else {
            let validData = this.handleEmptyValidationCheck();
            let data = {
                DummyCode: this.state.dummyCode,
                DummyDescription: this.state.dummyDescription,
                Status: 0,
                Category: this.state.selectedCategory,
                Brand: this.state.selectedBrand,
                ReferenceMasterSku: this.state.selectedReferenceMasterSku,
                // MappedMasterSku: this.state.selectedMasterSku
            }
            if (validData) {
                this.setState({
                    submitInno: true
                }, () => {
                    this.props.createInnovationPromotion(data);
                })
            }
        }
    }

    handleDeactivateActivity = () => {
        let validData = this.handleEmptyValidationCheck();
        let cpId = this.props.location.search.substr(4,);
        if (validData) {
            this.setState({
                deactiveCP: true
            }, () => {
                this.props.deactivateConsumerPromotion(cpId);
            })
        }
    }

    handleFlag = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    };

    handleCurrentYearVolumeChange = (e, item) => {
        let currentYearVolume = [...this.state.currentYearInnovationVolume];

        for (var i in currentYearVolume) {
            if (currentYearVolume[i].WeekNo === item.WeekNo) {
                this.checkSingleValueForDraftCheck(parseFloat(currentYearVolume[i].Volume), e.target.value ? parseFloat(e.target.value) : 0);
                currentYearVolume[i].Volume = e.target.value ? parseFloat(e.target.value) : '';
                break;
            }
        }

        this.setState({
            currentYearInnovationVolume: currentYearVolume
        })
    };

    handleNextYearVolumeChange = (e, item) => {
        let nextYearVolume = [...this.state.nextYearInnovationVolume];

        for (var i in nextYearVolume) {
            if (nextYearVolume[i].WeekNo === item.WeekNo) {
                this.checkSingleValueForDraftCheck(parseFloat(nextYearVolume[i].Volume), e.target.value ? parseFloat(e.target.value) : 0);
                nextYearVolume[i].Volume = parseFloat(e.target.value);
                break;
            }
        }

        this.setState({
            nextYearInnovationVolume: nextYearVolume
        })
    };

    addInnovationGuidInVol = (id) => {
        let currentYearVolume = [...this.state.currentYearInnovationVolume];
        let nextYearVolume = [...this.state.nextYearInnovationVolume];
        for (var i in currentYearVolume) {
            currentYearVolume[i].Innovation = id;
        }
        for (var j in nextYearVolume) {
            nextYearVolume[j].Innovation = id;
        }

        this.props.postInnovationVolume([...currentYearVolume, ...nextYearVolume])
    };

    handleSelectAllJCWeek = () => {
        this.setState({
            selectAllJCWeek: !this.state.selectAllJCWeek
        })
    };

    handleWeekSelect = (value) => {
        this.setState({
            selectedWeek: value.value
        })
    };

    handleRegionValueChange = (e, value) => {
        let region = [...this.state.regionSplit];

        if (this.state.selectAllJCWeek) {
            for (var j in region) {
                if (region[j].Name === value.Name) {
                    this.checkSingleValueForDraftCheck(parseFloat(region[j].value), e.target.value ? parseFloat(e.target.value) : 0);
                    region[j].Value = parseFloat(e.target.value);
                }
            }

        } else {
            for (var i in region) {
                if (region[i].guid === value.guid) {
                    this.checkSingleValueForDraftCheck(parseFloat(region[i].value), e.target.value ? parseFloat(e.target.value) : 0);
                    region[i].Value = parseFloat(e.target.value);
                    break;
                }
            }
        }
        this.setState({
            regionSplit: region,
            regionSplitTemp: this.groupRegionOrChannelData(region),
        })
    }



    handleChannelValueChange = (e, value) => {
        let channel = [...this.state.channelSplit];

        if (this.state.selectAllJCWeek) {
            for (var j in channel) {
                if (channel[j].Name === value.Name) {
                    this.checkSingleValueForDraftCheck(parseFloat(channel[j].value), e.target.value ? parseFloat(e.target.value) : 0);
                    channel[j].Value = parseFloat(e.target.value);
                }
            }

        } else {
            for (var i in channel) {
                if (channel[i].guid === value.guid) {
                    this.checkSingleValueForDraftCheck(parseFloat(channel[i].value), e.target.value ? parseFloat(e.target.value) : 0);
                    channel[i].Value = parseFloat(e.target.value);
                    break;
                }
            }
        }
        this.setState({
            channelSplit: channel,
            channelSplitTemp: this.groupRegionOrChannelData(channel),
        })
    };

    extractRegionChannelSpilt = (apiData) => {
        if (apiData) {
            this.setState({
                channelSplit: apiData.channel ? [...apiData.channel] : [],
                regionSplit: apiData.regional ? [...apiData.regional] : [],
                channelSplitTemp: this.groupRegionOrChannelData(apiData.channel),
                regionSplitTemp: this.groupRegionOrChannelData(apiData.regional),
            })

        }
    };

    handleRegionalChannelSplitSubmit = () => {
        let regions = [...this.state.regionSplit];
        let channels = [...this.state.channelSplit];
        let id = this.props.location.search.substr(4,);


        if (this.state.existingActivity) {
            this.props.postRegionChannelSplit(id ? id : this.props.innovation.guid, [...regions, ...channels]);
        }
        else {
            CustomToast('error', 'Click on save draft first!');
        }
    };

    handleCurrentYearVolumeFileUpload = (data, fileInfo) => {
        const randomString = Math.random().toString(36);
        let currentYearVolume = [...this.state.currentYearInnovationVolume];

        if (data.length === currentYearVolume.length) {
            for (var i in data) {
                currentYearVolume[i].Volume = parseFloat(data[i].volume);
            }

            this.setState({
                currentYearInnovationVolume: currentYearVolume,
                isDraftSaved: false,
                csvFileReset: randomString
            })
        }
        else {
            this.setState({
                csvFileReset: randomString
            })
            CustomToast('error', 'Data in CSV does not match current weeks!')
        }
    };

    handleNextYearVolumeFileUpload = (data, fileInfo) => {
        const randomString = Math.random().toString(36);
        let nextYearVolume = [...this.state.nextYearInnovationVolume];

        if (data.length === nextYearVolume.length) {
            for (var i in data) {
                nextYearVolume[i].Volume = parseFloat(data[i].volume);
            }

            this.setState({
                nextYearInnovationVolume: nextYearVolume,
                isDraftSaved: false,
                csvFileReset: randomString
            })
        }
        else {
            this.setState({
                csvFileReset: randomString
            })
            CustomToast('error', 'Data in CSV does not match current weeks!')
        }
    };

    handleDownloadCurrentYearPromotionCSV = () => {
        let currentYearVolume = [...this.state.currentYearInnovationVolume];
        if (currentYearVolume.length) {
            let csvContent = "data:text/csv;charset=utf-8,"
                + "volume\n" + currentYearVolume.map(e => e.Volume).join("\n");

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `innovation_volume_${new Date().getFullYear()}.csv`);
            document.body.appendChild(link); // Required for FF

            link.click();
        }
    };

    handleDownloadNextYearPromotionCSV = () => {
        let nextYearVolume = [...this.state.nextYearInnovationVolume];
        if (nextYearVolume.length) {
            let csvContent = "data:text/csv;charset=utf-8,"
                + "volume\n" + nextYearVolume.map(e => e.Volume).join("\n");

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `innovation_volume_${new Date().getFullYear() + 1}.csv`);
            document.body.appendChild(link); // Required for FF

            link.click();
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.productCategoriesArray?.length
            && this.props.productBrandsArray?.length && this.props.productMasterSkusArray?.length &&
            this.state.getData) {
            if (this.props.innovationById && this.state.getData) {
                if (this.props.innovationById?.guid) {
                    this.extractDataFromAPIResponse(this.props.innovationById);
                    this.setState({
                        getData: false,
                        isDraftSaved: true
                    })
                }
            }
        }

        if (prevProps.startWeek !== this.props.startWeek) {
            this.createInnovationVolumeList(this.props.startWeek);
        }

        if (prevProps.innovation !== this.props.innovation) {
            if (this.props.innovation?.guid) {
                CustomToast('success', 'Draft Saved!');
                this.addInnovationGuidInVol(this.props.innovation.guid);
                this.setState({
                    isDraftSaved: true,
                    existingActivity: true
                }, () => {
                    this.handleRegionalChannelSplitSubmit();
                })
                window.history.pushState("", "", `/innovationform/?id=${this.props.innovation.guid}`);
            }
        }

        if (prevProps.innovationVolume !== this.props.innovationVolume) {
            if (this.props.innovation?.length) {
                this.setState({
                    isDraftSaved: true
                })
            }
        }

        if ((prevProps.updateInnovation !== this.props.updateInnovation) && this.props.updateInnovation && this.state.updateInno) {
            if (this.props.updateInnovation.guid) {
                if (this.state.activating) {
                    CustomToast('success', 'Promotion Submitted!');
                    this.props.history.push('/innovationlist');
                }
                else {
                    CustomToast('success', 'Draft Saved!');
                    this.setState({
                        updateInno: false,
                        isDraftSaved: true
                    }, () => {
                        this.handleRegionalChannelSplitSubmit();
                    });
                }
            }
        }

        if (this.props.innovationHasError && this.state.submitInno) {
            CustomToast('error', 'Promotion Creation Failed!');
            this.setState({
                submitInno: false
            });
        }

        if (this.props.updateInnovationHasError && this.state.updateInno) {
            CustomToast('error', 'Save Draft Failed!');
            this.setState({
                updateInno: false
            });
        }

        if (prevProps.regionChannelSplit !== this.props.regionChannelSplit) {
            this.extractRegionChannelSpilt(this.props.regionChannelSplit);
        }

        if (prevProps.submittingRegionChannelSplit !== this.props.submittingRegionChannelSplit) {
            if (this.props.submittingRegionChannelSplit?.length) {
                CustomToast('success', 'Region Channel Split Submitted!');
            }
        }
    };

    render() {
        const { myBrands, selectedBrand, selectedCategory, myMasterSkus, selectedMasterSku,
            dummyCode, selectedReferenceMasterSku, isDraftSaved, isOpen, currentYearInnovationVolume,
            nextYearInnovationVolume, dummyDescription, promoStatus,
            regionSplitTemp, channelSplitTemp, existingActivity, weeksArray, selectedWeek,
            selectAllJCWeek } = this.state;

        const { productCategoriesArray, productMasterSkusArray, isInnovationLoading,
            innovationVolumeIsLoading, isGetInnovationByIdLoading, submittingRegionChannelSplitIsLoading,
            updateInnovationLoading } = this.props;
        return (
            <>
                {
                    (isInnovationLoading || innovationVolumeIsLoading || isGetInnovationByIdLoading
                        || !currentYearInnovationVolume.length || !nextYearInnovationVolume.length) ?
                        <Loader flag={true} />
                        :
                        <div className="page-container">
                            <div className='df'>
                                <div className='component-heading'>Innovation</div>
                                <div className='df cp-top-left-ctas justifyContent-fe width-100-pre'>
                                    <div className='df alignItem-center' style={{ marginRight: '32px', cursor: 'pointer' }} onClick={this.handleFlag}>
                                        <span className='innovation-cta-label'><u>View Region-Channel Split</u></span>
                                    </div>

                                    <div className='df alignItem-center' style={{ cursor: 'pointer' }} onClick={() => existingActivity ? !isDraftSaved ? this.handleSaveDraft() : void 0 : this.handleSubmitActivity(0)}>
                                        <img className='cta-icon' src={SaveIcon} alt="" />
                                        {isDraftSaved ?
                                            <span className='innovation-cta-label ml-12'><u>Saved</u></span>
                                            :
                                            <span className='innovation-cta-label ml-12'><u>Save Draft</u></span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='df'>
                                <div className='cp-form-container' style={{ width: '50%', height: '700px' }}>

                                    <div className='df justifyContent-sb'>
                                        <div className='df'>
                                            <span className='cp-form-heading'>Innovation Detail</span>
                                            {promoStatus === 0 ? <span className='cp-form-status draft-status'>DRAFT</span> : null}
                                            {promoStatus === 1 ? <span className='cp-form-status active-status'>ACTIVE</span> : null}
                                            {promoStatus === 2 ? <span className='cp-form-status deactive-status'>DEACTIVE</span> : null}
                                            {promoStatus === 3 ? <span className='cp-form-status'>FINALIZED</span> : null}
                                        </div>


                                    </div>

                                    <div className='cp-filter-group' style={{ width: '100%' }}>

                                        <div className='df fdi-col mb-32 '>
                                            <label className='cp-filter-label'>Category<span className='required-mark'>*</span></label>
                                            <div className='f-s-13'>
                                                <CustomSelect.MyCustomSelect
                                                    placeholder={"Category"}
                                                    allowSelectAll={false}
                                                    isDisabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                                    isMulti={false}
                                                    options={
                                                        productCategoriesArray
                                                            ? productCategoriesArray?.sort(compare).map(item => ({
                                                                value: item.guid,
                                                                label: item.Name
                                                            }))
                                                            : []
                                                    }
                                                    onChange={this.handleCategory}
                                                    value={
                                                        productCategoriesArray && selectedCategory
                                                            ? productCategoriesArray
                                                                .filter(item => {
                                                                    return selectedCategory === item.guid;
                                                                })
                                                                .map(item => {
                                                                    return {
                                                                        value: item.guid,
                                                                        label: item.Name
                                                                    };
                                                                }) : []
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className='df fdi-col mb-32 '>
                                            <label className='cp-filter-label'>Brand<span className='required-mark'>*</span></label>
                                            <div className='f-s-13'>
                                                <CustomSelect.MyCustomSelect
                                                    placeholder={"Brand"}
                                                    allowSelectAll={false}
                                                    isDisabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                                    isMulti={false}
                                                    options={
                                                        myBrands.length !== 0
                                                            ? myBrands.sort(compare).map(item => ({
                                                                value: item.guid,
                                                                label: item.Name
                                                            }))
                                                            : []
                                                    }
                                                    onChange={this.handleBrandChange}
                                                    value={
                                                        myBrands && selectedBrand
                                                            ? myBrands
                                                                .filter(item => {
                                                                    return selectedBrand === item.guid;
                                                                })
                                                                .map(item => {
                                                                    return {
                                                                        value: item.guid,
                                                                        label: item.Name
                                                                    };
                                                                }) : []
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className='df fdi-col mb-32'>
                                            <label className='cp-filter-label'>Dummy MSKU Code<span className='required-mark'>*</span></label>
                                            <input
                                                type='text'
                                                className='cp-input '
                                                disabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                                placeholder='Enter Dummy MSKU Code*'
                                                name='dummyCode'
                                                value={dummyCode}
                                                onChange={this.handleDummySKUCodeChange}
                                            />
                                        </div>

                                        <div className='df fdi-col mb-32'>
                                            <label className='cp-filter-label'>Dummy MSKU Description<span className='required-mark'>*</span></label>
                                            <textarea
                                                type='text'
                                                className='cp-input '
                                                style={{ resize: 'none', height: '92px', fontFamily: 'Source Sans Pro' }}
                                                disabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                                placeholder='Enter Dummy MSKU Description'
                                                name='dummyCode'
                                                value={dummyDescription}
                                                onChange={this.handleDummyDescriptionChange}
                                            />
                                        </div>

                                        <div className='df fdi-col mb-32 '>
                                            <label className='cp-filter-label'>Reference MSKU<span className='required-mark'>*</span></label>
                                            <div className='f-s-13'>
                                                <CustomSelect.MyCustomSelect
                                                    placeholder={"Reference MSKU"}
                                                    allowSelectAll={false}
                                                    isDisabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                                    isMulti={false}
                                                    options={
                                                        productMasterSkusArray
                                                            ? productMasterSkusArray.sort(compare).map(item => ({
                                                                value: item.guid,
                                                                label: `${item.Description} (${item.Code}) `
                                                            }))
                                                            : []
                                                    }
                                                    onChange={this.handleReferenceMasterSkusChange}
                                                    value={
                                                        productMasterSkusArray && selectedReferenceMasterSku
                                                            ? productMasterSkusArray
                                                                .filter(item => {
                                                                    return selectedReferenceMasterSku === item.guid;
                                                                })
                                                                .map(item => {
                                                                    return {
                                                                        value: item.guid,
                                                                        label: `${item.Description} (${item.Code}) `
                                                                    };
                                                                })
                                                            : []
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className='df fdi-col mb-32 '>
                                            <label className='cp-filter-label'>Mapped MSKU</label>
                                            <div className='f-s-13'>
                                                <CustomSelect.MyCustomSelect
                                                    placeholder={"MSKU"}
                                                    allowSelectAll={false}
                                                    isDisabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                                    isMulti={false}
                                                    options={
                                                        myMasterSkus
                                                            ? myMasterSkus.sort(compare).map(item => ({
                                                                value: item.guid,
                                                                label: `${item.Description} (${item.Code}) `
                                                            }))
                                                            : []
                                                    }
                                                    onChange={this.handleMasterSkusChange}
                                                    value={
                                                        myMasterSkus && selectedMasterSku
                                                            ? myMasterSkus
                                                                .filter(item => {
                                                                    return selectedMasterSku === item.guid;
                                                                })
                                                                .map(item => {
                                                                    return {
                                                                        value: item.guid,
                                                                        label: `${item.Description} (${item.Code}) `
                                                                    };
                                                                })
                                                            : []
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </div>


                                </div>

                                <InnovationFormTable
                                    year={new Date().getFullYear()}
                                    data={currentYearInnovationVolume}
                                    handleVolumeValue={this.handleCurrentYearVolumeChange}
                                    isDisabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                    handleFileUpload={this.handleCurrentYearVolumeFileUpload}
                                    csvFileReset={this.state.csvFileReset}
                                    handleDownloadPromotionCSV={this.handleDownloadCurrentYearPromotionCSV}
                                />
                                <InnovationFormTable
                                    year={new Date().getFullYear() + 1}
                                    data={nextYearInnovationVolume}
                                    handleVolumeValue={this.handleNextYearVolumeChange}
                                    isDisabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                                    handleFileUpload={this.handleNextYearVolumeFileUpload}
                                    csvFileReset={this.state.csvFileReset}
                                    handleDownloadPromotionCSV={this.handleDownloadNextYearPromotionCSV}
                                />
                            </div>

                            <div className='df justifyContent-fe alignItem-center'>

                                {promoStatus === 0 ?
                                    <>
                                        {
                                            isInnovationLoading || updateInnovationLoading ?
                                                <button className='in-btns in-primary-btn'>Activating...</button>
                                                :
                                                <button className='in-btns in-primary-btn' onClick={() => this.handleSubmitActivity(1)}>Activate</button>
                                        }
                                    </>
                                    :
                                    null
                                }
                                {
                                    promoStatus === 1 ?
                                        <>
                                            {
                                                updateInnovationLoading ?
                                                    <button className='in-btns in-primary-btn'>Deactivating...</button>
                                                    :
                                                    <button className='in-btns in-primary-btn' onClick={() => this.handleSubmitActivity(2)}>Deactivate</button>
                                            }
                                        </>
                                        :
                                        null
                                }

                            </div>
                        </div>
                }

                {
                    isOpen ?
                        <InnovationRegionChannelSplit
                            isOpen={isOpen}
                            flagHandle={this.handleFlag}
                            regionData={regionSplitTemp}
                            channelData={channelSplitTemp}
                            weeksArray={weeksArray}
                            selectedWeek={selectedWeek}
                            selectAllJCWeek={selectAllJCWeek}
                            handleSelectAllJCWeek={this.handleSelectAllJCWeek}
                            handleWeekSelect={this.handleWeekSelect}
                            handleRegionValueChange={this.handleRegionValueChange}
                            handleChannelValueChange={this.handleChannelValueChange}
                            handleRegionalChannelSplitSubmit={this.handleRegionalChannelSplitSubmit}
                            submittingRegionChannelSplitIsLoading={submittingRegionChannelSplitIsLoading}
                            isDisabled={promoStatus === 1 || promoStatus === 2 ? true : false}
                        />
                        :
                        null
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        productCategoriesArray: state.ProductReducer.productCategories,
        productBrandsArray: state.ProductReducer.productBrands,
        productMasterSkusArray: state.ProductReducer.productMasterSkus,
        startWeek: state.DurationReducer.startWeek,
        isInnovationLoading: state.InnovationReducer.isInnovationLoading,
        innovation: state.InnovationReducer.innovation,
        innovationHasError: state.InnovationReducer.innovationHasError,
        innovationVolumeIsLoading: state.InnovationReducer.innovationVolumeIsLoading,
        innovationVolume: state.InnovationReducer.innovationVolume,
        innovationVolumeHasError: state.InnovationReducer.innovationVolumeHasError,
        isGetInnovationByIdLoading: state.InnovationReducer.isGetInnovationByIdLoading,
        innovationById: state.InnovationReducer.innovationById,
        getInnovationByIdHasError: state.InnovationReducer.getInnovationByIdHasError,
        updateInnovation: state.InnovationReducer.updateInnovation,
        updateInnovationLoading: state.InnovationReducer.updateInnovationLoading,
        updateInnovationHasError: state.InnovationReducer.updateInnovationHasError,
        submittingRegionChannelSplit: state.InnovationReducer.submittingRegionChannelSplit,
        submittingRegionChannelSplitIsLoading: state.InnovationReducer.submittingRegionChannelSplitIsLoading,
        submittingRegionChannelSplitHasError: state.InnovationReducer.submittingRegionChannelSplitHasError,
        regionChannelSplit: state.InnovationReducer.regionChannelSplit,
        regionChannelSplitIsLoading: state.InnovationReducer.regionChannelSplitIsLoading,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        productCategories: () => {
            return dispatch(ProductMiddleware.get_categories());
        },
        productBrands: () => {
            return dispatch(ProductMiddleware.get_brands());
        },
        productMasterSkus: () => {
            return dispatch(ProductMiddleware.get_master_skus());
        },
        createInnovationPromotion: (data) => {
            return dispatch(InnovationMiddleware.createInnovationPromotion(data))
        },
        getConsumerPromotionById: (id) => {
            return dispatch(InnovationMiddleware.getConsumerPromotionById(id))
        },
        getStartWeek: (year) => {
            return dispatch(DurationMiddleware.get_startWeek(year));
        },
        postInnovationVolume: (data) => {
            return dispatch(InnovationMiddleware.postInnovationVolume(data))
        },
        patchUpdateInnovation: (id, data) => {
            return dispatch(InnovationMiddleware.patchUpdateInnovation(id, data))
        },
        postRegionChannelSplit: (id, data) => {
            return dispatch(InnovationMiddleware.postRegionChannelSplit(id, data))
        },
        getRegionChannelSplitByMskuId: (id) => {
            return dispatch(InnovationMiddleware.getRegionChannelSplitByMskuId(id))
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(InnovationForm);
